// extracted by mini-css-extract-plugin
module.exports = {"status":"_17442","img":"_2637","price":"_2221","text":"_10214","btn":"_6973"};